import React, { useEffect, useRef, useState } from "react";
import api, { mediaUrl, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [caption, setCaption] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/admin/gallery").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.post("/admin/gallery", { caption, storage_path: data.path });
      setCaption("");
      toast.success("Foto aggiunta");
      await load();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Errore");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare questa foto?")) return;
    try {
      await api.delete(`/admin/gallery/${id}`);
      toast.success("Eliminata");
      await load();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Errore");
    }
  };

  return (
    <div>
      <span className="label-eyebrow text-gray-500">Racing Team</span>
      <h1 className="font-display uppercase text-4xl mt-1">Gallery</h1>

      <div className="card-flat p-6 mt-8 flex flex-col md:flex-row gap-4 items-start md:items-end">
        <div className="flex-1 w-full">
          <label className="label-eyebrow text-gray-500 block mb-2">Didascalia (facoltativa)</label>
          <input
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3"
            data-testid="gallery-caption"
          />
        </div>
        <input type="file" ref={fileRef} accept="image/*,video/*" className="hidden" onChange={upload} />
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="btn-orange label-eyebrow px-5 py-3 inline-flex items-center gap-2 disabled:opacity-60"
          data-testid="gallery-upload"
        >
          <Upload size={14} /> {uploading ? "Caricamento..." : "Carica foto"}
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
        {items.map((g) => (
          <div key={g.id} className="relative group card-flat overflow-hidden" data-testid={`gal-${g.id}`}>
            <div className="aspect-square bg-cover bg-center" style={{ backgroundImage: `url(${mediaUrl(g.url || g.storage_path)})` }} />
            {g.caption && <div className="text-xs p-2 text-gray-600 truncate">{g.caption}</div>}
            <button
              onClick={() => remove(g.id)}
              className="absolute top-2 right-2 bg-white/90 p-2 opacity-0 group-hover:opacity-100 transition"
              data-testid={`gal-del-${g.id}`}
            >
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        {items.length === 0 && <div className="text-gray-500 col-span-full">Nessuna foto ancora.</div>}
      </div>
    </div>
  );
}
